import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup } from 'react-bootstrap';

const Addon = props => (
  <InputGroup.Addon>
    {
      /* {props.icon && <Icon name={props.icon} />}
      {props.text && props.text}
      {props.iconName && <Icon name={props.iconName} />} */
    }
  </InputGroup.Addon>
);

Addon.propTypes = {
  iconName: PropTypes.string
};

export default Addon;
